import { AbsStoreWorkProcess, } from './AbsStoreWorkProcess';
export class StoreWorkProcessPost extends AbsStoreWorkProcess {
    createReqBody() {
        const data = {
            title: this.reqBody.title,
            body: this.reqBody.body,
            isImportant: this.reqBody.isImportant,
        };
        if (this.reqBody.stores && this.reqBody.stores.length > 0) {
            data.stores = this.reqBody.stores;
        }
        // 총판일 경우만 hubId를 보낸다.
        if (this.reqBody.isHead
            && this.reqBody.hubId) {
            data.hubId = this.reqBody.hubId;
        }
        return data;
    }
}
